<style>
	:global(.mdc-notched-outline__notch) {
		width: 100%;
	}
</style>

<script lang="ts">
	import Card from '@smui/card';
	import Select, { Option } from '@smui/select';
	import Input from '@smui/textfield';
	import { _ } from 'svelte-i18n';
	import FieldLoading from '../../../..//shared/components/common/Loading/FieldLoading.svelte';
	import FormLoading from '../../../..//shared/components/common/Loading/FormLoading.svelte';
	import Title from '../../../..//shared/components/common/Title.svelte';
	import Area from '../../../../shared/models/Area/Area';
	import AziendaEnte from '../../../../shared/models/AziendaEnte/AziendaEnte';
	import TipoAziendaEnte from '../../../../shared/models/AziendaEnte/TipoAziendaEnte';
	import { hasRoleSysAdmin } from '../../../../shared/stores';

	export let params = {
		id: '0',
	};

	let disabled = true;

	let [data, loading, error] = AziendaEnte.get(params.id);
	let [dataTipiAziendaEnte, loadingTipiAziendaEnte, errorTipiAziendaEnte] = TipoAziendaEnte.getList();
	let [dataAree, loadingAree, errorAree] = Area.getList();

	let selectedTipoAziendaEnte: TipoAziendaEnte | undefined = undefined;
	$: selectedTipoAziendaEnte = $data.tipoAziendaEnte;

	let selectedArea: Area | undefined = undefined;
	$: selectedArea = $data.area;

	$: {
		if (!$data.nomeAziendaEnte || !$data.nome || !$data.cognome || !$data.email || !$data.tipoAziendaEnteId) {
			disabled = true;
		} else {
			if ($hasRoleSysAdmin) {
				if (!selectedArea?.id) {
					disabled = true;
				} else {
					disabled = false;
				}
			} else {
				disabled = false;
			}
		}
	}

	function onSubmit() {
    $data.scuola = true;
    
    const formData = new FormData();
    
    for (let key in $data) {
        if ($data[key] !== null && $data[key] !== undefined) {
            formData.append(key, $data[key]);
        }
    }
    
    [data, loading, error] = AziendaEnte.save(formData);
}
</script>

<Card class="md:px-8 md:py-8" padded>
	<div class="flex justify-between">
		<Title title="{$_('page.school.detail.title')}" />
		<div class="sm:flex-nowrap sm:space-x-4 flex flex-wrap">
			<button disabled="{disabled}" type="submit" form="form" class="btn-white h-14 w-14 sm:h-16 sm:w-16">
				<span class="material-icons-outlined text-2xl leading-[3rem] sm:text-3xl sm:leading-[3.25rem]">save</span>
			</button>
		</div>
	</div>
	{#if $loading}
		<FormLoading />
	{:else}
		<form on:submit|preventDefault="{onSubmit}" id="form" class="md:grid-cols-3 grid grid-cols-1">
			<Input required label="{$_('page.school.detail.school_name')}" bind:value="{$data.nomeAziendaEnte}" class="md:col-start-2" />
			{#if $loadingTipiAziendaEnte}
					<FieldLoading customClass="md:col-start-2" />
			{:else}
				<Select
					required
					label="{$_('page.school.detail.school_type')}"
					key="{(tipoAziendaEnte) => `${(tipoAziendaEnte && tipoAziendaEnte?.id) || ''}`}"
					bind:value="{selectedTipoAziendaEnte}"
					class="md:col-start-2"
				>
					{#if $dataTipiAziendaEnte.response}
						{#each $dataTipiAziendaEnte.response as tipoAziendaEnte (tipoAziendaEnte?.id)}
							{#if tipoAziendaEnte?.descrizione}
								<Option
									value="{tipoAziendaEnte}"
									on:click="{() => {
										$data.tipoAziendaEnte = tipoAziendaEnte;
										$data.tipoAziendaEnteId = tipoAziendaEnte.id;
									}}">{tipoAziendaEnte.descrizione}</Option
								>
							{/if}
						{/each}
					{/if}
				</Select>
			{/if}
			<Input required label="{$_('page.school.detail.mm_name')}" bind:value="{$data.nome}" class="md:col-start-2" />
			<Input required label="{$_('page.school.detail.mm_surname')}" bind:value="{$data.cognome}" class="md:col-start-2" />
			<Input required label="{$_('page.school.detail.mm_email')}" bind:value="{$data.email}" class="md:col-start-2" />
			{#if $hasRoleSysAdmin}
				{#if $loadingAree}
					<FieldLoading customClass="md:col-start-2" />
				{:else}
					<Select
						required
						label="{$_('page.school.detail.area')}"
						key="{(area) => `${(area && area?.id) || ''}`}"
						bind:value="{selectedArea}"
						class="md:col-start-2"
					>
						{#if $dataAree.response}
							{#each $dataAree.response as area (area?.id)}
								{#if area?.nomeComune}
									<Option
										value="{area}"
										on:click="{() => {
											$data.area = area;
											$data.areaId = area.id;
										}}">{area.nomeComune}</Option
									>
								{/if}
							{/each}
						{/if}
					</Select>
				{/if}
			{/if}
			<Input label="{$_('page.school.detail.province')}" bind:value="{$data.provincia}" class="md:col-start-2" />
			<Input label="{$_('page.school.detail.city')}" bind:value="{$data.citta}" class="md:col-start-2" />
			<Input label="{$_('page.school.detail.postal_code')}" bind:value="{$data.cap}" class="md:col-start-2" />
			<Input label="{$_('page.school.detail.address')}" bind:value="{$data.indirizzo}" class="md:col-start-2">
				<svelte:fragment slot="trailingIcon">
					{#if $data.id > 0}
						{#if $data.provincia && $data.citta && $data.cap && $data.indirizzoOK}
							<span title="{$_('page.school.detail.valid_address')}" class="material-icons-outlined" style="color: green">fmd_good</span
							>
						{:else}
							<span title="{$_('page.school.detail.not_valid_address')}" class="material-icons-outlined" style="color: red"
								>wrong_location</span
							>
						{/if}
					{/if}
				</svelte:fragment>
			</Input>
		</form>
	{/if}
</Card>
